import * as React from "react";
const SVGComponent = ({ color, ...props }) => (
    <svg
        width={17}
        height={16}
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M8.95312 12.668L8.95312 3.33464"
            stroke={color}
            strokeWidth={1.33333}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.28386 8L8.95052 3.33333L13.6172 8"
            stroke={color}
            strokeWidth={1.33333}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default SVGComponent;

SVGComponent.defaultProps = {
    color: "#50A71E",

}